exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".capacity-panel[data-v-0dd14b4e]{position:fixed;top:105px;left:50%;z-index:2000;width:760px;padding:20px;background:#fff;border:1px solid #dcdfe6;border-radius:2px;box-shadow:0 2px 12px 0 rgba(0,0,0,.1);transform:translateX(-50%)}.capacity-panel-title[data-v-0dd14b4e]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:26px;color:#303133;font-size:16px}.capacity-panel-title .el-icon-close[data-v-0dd14b4e]{color:#909399;cursor:pointer}.capacity-panel .el-input-number[data-v-0dd14b4e]{width:100%}.capacity-limit-tip[data-v-0dd14b4e]{display:block;margin-top:6px;color:#909399;line-height:18px}.capacity-selected[data-v-0dd14b4e]{margin-left:16px;color:#909399}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0dd14b4e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/user/index.vue
// module id = 2428
// module chunks = 0